import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/vt323/400.css";
import "./styles.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import { App } from "./App";
import { createApi } from "./api";
import { type Deps, DepsProvider } from "./context";
import { fakePasskey, webauthnPasskey } from "./lib/passkey";

async function deps(): Promise<Deps> {
  const base = {
    now: () => Date.now(),
    copy: (text: string) => navigator.clipboard.writeText(text),
    redirect: (url: string) => window.location.assign(url),
  };
  if (import.meta.env.VITE_MOCK_API === "1") {
    // Loaded only in mock mode so the fake server never ships in the production bundle's main chunk.
    const [{ createMockServer }, { SEED_NOW }] = await Promise.all([import("./mock/server"), import("./mock/data")]);
    // Story clock: starts at 3:10 am on Maya's Thursday and runs at real speed.
    const started = Date.now();
    const now = () => SEED_NOW + (Date.now() - started);
    const mock = createMockServer({ now, delayMs: 250, onlineAfterPolls: 2 });
    return {
      ...base,
      now,
      api: createApi({ fetch: mock.fetch }),
      passkey: fakePasskey(),
      pollMs: 1500,
      redirect: (url) => console.info(`[mock] would go to ${url}`),
    };
  }
  return { ...base, api: createApi({ fetch: (i, init) => fetch(i, init) }), passkey: webauthnPasskey, pollMs: 2000 };
}

const root = document.getElementById("root");
if (!root) throw new Error("index.html is missing #root");

void deps().then((d) =>
  createRoot(root).render(
    <StrictMode>
      <BrowserRouter>
        <DepsProvider deps={d}>
          <App />
        </DepsProvider>
      </BrowserRouter>
    </StrictMode>,
  ),
);
